<!--
  Encrypted-vs-cleartext ring: the package's Donut (a conic-gradient ring with
  the share in the middle) beside two Meters. "Encrypted" is a port-based
  heuristic today (443, 8443, …); we say so next to the label so it isn't read
  as ground truth.

  `compact` drops the meters for the narrow summary tiles on /traffic.
-->
<script lang="ts">
	import { Donut, Meter } from '@navitech/ui';

	const {
		encrypted,
		cleartext,
		compact = false,
	}: { encrypted: number; cleartext: number; compact?: boolean } = $props();

	const total = $derived(Math.max(0, encrypted + cleartext));
	const pct = $derived(total === 0 ? 0 : Math.round((encrypted / total) * 100));
</script>

<div class="flex flex-wrap items-center gap-4">
	<Donut value={pct} caption="encrypted" label="{pct}% of traffic encrypted" size={96} thickness={11} />

	{#if compact}
		<div class="min-w-0 text-xs text-text-dim">
			<div class="font-mono">{encrypted.toLocaleString()} TLS</div>
			<div class="font-mono">{cleartext.toLocaleString()} cleartext</div>
			<div class="mt-1">port heuristic</div>
		</div>
	{:else}
		<div class="flex min-w-[150px] flex-1 flex-col gap-3 text-text-dim">
			<Meter label="TLS / encrypted" value={pct} valueText={encrypted.toLocaleString()} tone="accent" />
			<Meter label="Cleartext" value={100 - pct} valueText={cleartext.toLocaleString()} tone="warn" />
			<p class="text-xs">port heuristic · not TLS inspection</p>
		</div>
	{/if}
</div>
